import React from 'react';
import { GraduationCap } from 'lucide-react';
import { useSpecialties } from '../../lib/useSpecialties';

const POPULAR = [
  'south_asian_bridal', 'henna_mehndi', 'eyebrow_threading', 'sugaring',
  'curly_coily_specialist', 'silk_press', 'braids_knotless', 'biab', 'melanin_rich_skincare',
];

const chip = (on) => `text-xs px-3 py-1.5 rounded-full border transition-colors ${on ? 'bg-[#1A1A1A] text-white border-[#1A1A1A]' : 'bg-white text-stone-600 border-[#E6E4DD] hover:border-[#D4AF37]'}`;

export function SpecialtyFilter({ category, specialty, setSpecialty, coOp, setCoOp }) {
  const data = useSpecialties();
  const all = Object.values(data).flat();
  const options = category && category !== 'all'
    ? data[category] || []
    : POPULAR.map((id) => all.find((s) => s.id === id)).filter(Boolean);

  return (
    <div className="mt-4 flex flex-wrap items-center gap-2" data-testid="specialty-filter">
      <button type="button" onClick={() => setCoOp(!coOp)} className={`${chip(coOp)} inline-flex items-center gap-1.5`} data-testid="filter-co-op" aria-pressed={coOp}>
        <GraduationCap className="h-3.5 w-3.5" />Student Co-op packages
      </button>
      <span className="w-px h-5 bg-[#E6E4DD] mx-1" aria-hidden />
      {options.map((s) => (
        <button key={s.id} type="button" onClick={() => setSpecialty(specialty === s.id ? '' : s.id)}
          className={chip(specialty === s.id)} data-testid={`filter-specialty-${s.id}`} aria-pressed={specialty === s.id}>
          {s.name}
        </button>
      ))}
    </div>
  );
}
